import { BotSequenceType, FMSCapabilityKey, FMSObjectType } from "@swivl-mono/types";

import { SidebarLink } from "../../../Components/SidebarLink/SidebarLink";
import { SequenceStatusChip } from "./SequenceStatusChip";
import { useSequencesV3Context } from "./SequencesV3.Context";
import { SEQUENCE_TYPE_META, SEQUENCE_TYPE_ORDER } from "./sequenceTypeMeta";

interface SequenceTypeListProps {
  /** `${page.preamble}/page/sequences` — the list links below it. */
  basePath: string;
}

/** True when the type should be offered at this scope (ENG-3216 decisions 23/25: Abandoned Cart hides where no FMS can judge a cart). */
export function isSequenceTypeVisible(
  type: BotSequenceType,
  scopeKind: "org" | "group" | "location",
  supports: (key: FMSCapabilityKey, objectType: FMSObjectType) => boolean
): boolean {
  if (type !== BotSequenceType.ABANDONED_CART) return true;
  if (scopeKind !== "location") return true;
  return supports(FMSCapabilityKey.AbandonedCartCandidacy, FMSObjectType.Lead);
}

/** The left column: one link per sequence type (iterating the type enum) with its status. */
export function SequenceTypeList({ basePath }: SequenceTypeListProps): React.ReactElement {
  const { scope, config, fms } = useSequencesV3Context();

  return (
    <nav className="flex flex-col pt-2" aria-label="Sequence types">
      {SEQUENCE_TYPE_ORDER.filter((type) => isSequenceTypeVisible(type, scope.kind, fms.supports)).map((type) => {
        const meta = SEQUENCE_TYPE_META[type];
        return (
          <SidebarLink key={type} to={`${basePath}/${meta.slug}`} height={44}>
            <div className="flex w-full items-center justify-between gap-2 pr-1">
              <span>{meta.label}</span>
              <SequenceStatusChip effective={config.effective[type]} scopeKind={scope.kind} dirty={config.dirtyCount(type) > 0} />
            </div>
          </SidebarLink>
        );
      })}
    </nav>
  );
}
